// @flow

import React, { useState, useEffect, Fragment, useRef } from "react";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import {
  AdsumLoader,
  AdsumWebMap,
  ArrowPathPatternOptions,
  DotPathBuilder,
  DotPathBuilderOptions,
  PinUserObject,
  SingleFloorAnimation,
  DotPathSectionDrawer,
  DotPathSectionDrawerOptions,
  // LabelTextObject,
} from "@adactive/adsum-web-map";
import { LoadingScreenActions } from "@adactive/arc-loading-screen";
import ACA from "@adactive/adsum-utils/services/ClientAPI";
import { Map, MainActions, SelectionActions } from "@adactive/arc-map";
import _ from "lodash";
import selectionController from "@adactive/arc-map/src/controllers/SelectionController";
import PlacesController from "@adactive/arc-map/src/controllers/PlacesController";
import mapBackground from "./assets/bg.png";
import deviceConfig from "./services/Config";
import store from "./store/index";
import "./App.css";
import { getDrawPathSectionOptions, labelStyle } from "./utils/constants";
import WayFindingControls, {
  WayFindingControlsActions,
} from "@adactiveasia/adasia-wayfindingcontrols";
import { checkComputedPath, getPoi, getPlace } from "./utils/functions";

const historiesStorage = localStorage.getItem("histories")
  ? JSON.parse(localStorage.getItem("histories"))
  : [];

const historiesPoisStorage = localStorage.getItem("historiesPois")
  ? JSON.parse(localStorage.getItem("historiesPois"))
  : [];

  const ScrollList = ({ children, className }) => {
    const listRef = useRef(null);
    const thumbRef = useRef(null);
    const trackRef = useRef(null);
  
    const updateScrollbar = () => {
      const list = listRef.current;
      const thumb = thumbRef.current;
      const track = trackRef.current;
      if (!list || !thumb || !track) return;
  
      const needsScroll = list.scrollHeight > list.clientHeight;
  
      track.style.display = needsScroll ? 'block' : 'none';
  
      if (!needsScroll) return;
  
      const scrollRatio = list.scrollTop / (list.scrollHeight - list.clientHeight);
      const trackHeight = list.clientHeight;
      const thumbHeight = Math.max((list.clientHeight / list.scrollHeight) * trackHeight, 30);
      const thumbTop = scrollRatio * (trackHeight - thumbHeight);
  
      thumb.style.height = `${thumbHeight}px`;
      thumb.style.transform = `translateY(${thumbTop}px)`;
    };
  
    useEffect(() => {
      updateScrollbar();
    }, [children]);
  
    return (
      <div className="modal-search-list-wrapper">
        <div
          className={`modal-search-list ${className || ""}`}
          ref={listRef}
          onScroll={updateScrollbar}
        >
          {children}
        </div>
        <div className="custom-scrollbar-track" ref={trackRef}>
          <div className="custom-scrollbar-thumb" ref={thumbRef} />
        </div>
      </div>
    );
  };

function App() {
  const [configLoaded, setConfigLoaded] = useState(false);
  const [mapLoaded, setMapLoaded] = useState(false);
  const [percentage, setPercentage] = useState(0);
  const [awm, setAwm] = useState(null);
  const [defaultFloor, setDefaultFloor] = useState({});
  const [awmContainerRef] = useState(React.createRef());
  const [allPois, setAllPois] = useState([]);
  const [selectedObject, setSelectedObject] = useState(null);
  const [destinationPoi, setDestinationPoi] = useState(null);
  const [destinationObject, setDestinationObject] = useState(null);
  // const [destinationSearch, setDestinationSearch] = useState(null);
  // const [destinationSearchResult, setDestinationSearchResult] = useState(null);
  // const [sourcePoi, setSourcePoi] = useState(null);
  const [sourceObject, setSourceObject] = useState(null);
  // const [sourceSearch, setSourceSearch] = useState(null);
  // const [sourceSearchResult, setSourceSearchResult] = useState(null);
  // const [isSourceChanged, setIsSourceChanged] = useState(false);
  const [isActionEnabled, setIsActionEnabled] = useState(true);
  // const [selectedDestination, setSelectedDestination] = useState(null);
  const [allFloors, setAllFloors] = useState([]);
  // const [currentFloor, setCurrentFloor] = useState(null);
  // const [width, setWidth] = useState(window.innerWidth);
  // const [objects, setObjects] = useState([]);
  // const [isShowLoading, setIsShowLoading] = useState(false);
  // const [isShowSearchResult, setIsShowSearchResult] = useState(false);
  // const [activeSearch, setActiveSearch] = useState(null);
  const [isFormModalOpen, setIsFormModalOpen] = useState(false);
  const [isFormModalPoiOpen, setIsFormModalPoiOpen] = useState(false);
  const [isHistoryOpen, setIsHistoryOpen] = useState(true);
  const [isHistoryPoiOpen, setIsHistoryPoiOpen] = useState(true);
  const [keyword, setKeyword] = useState({
    from: "",
    to: "",
  });
  const [histories, setHistories] = useState(historiesStorage);
  const [historiesPois, setHistoriesPois] = useState(historiesPoisStorage);
  const [selectedFrom, setSelectedFrom] = useState(null);
  const [selectedPoi, setSelectedPoi] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isLoadingFinish, setIsLoadingFinish] = useState(false);
  const [userFloor, setUserFloor] = useState(null);

  const mapState = useSelector((state) => state.map.state);
  // const currentSelectedObject = useSelector(
  //   (state) => state.map.currentSelectedObject
  // );

  const urlParams = new URLSearchParams(window.location.search);

  const { wayfindingState, wayFindingControlsState } = useSelector(
    (state) => ({
      wayfindingState: state.map.wayfindingState,
      wayFindingControlsState: state.wayFindingControls,
    }),
    shallowEqual,
  );

  const currentFloor = useSelector((state) => state.map.currentFloor);

  const dispatch = useDispatch();
  // const isMobile = width <= 768 || navigator.userAgentData.mobile;

  // const handleWindowSizeChange = () => {
  //   setWidth(window.innerWidth);
  // };

  // useEffect(() => {
  //   window.addEventListener("resize", handleWindowSizeChange);
  //   return () => {
  //     window.removeEventListener("resize", handleWindowSizeChange);
  //   };
  // }, []);

  useEffect(() => {
    initDevice();
  }, []);

  useEffect(() => {
    loadMap();
  }, [mapState]);

  useEffect(() => {
    dispatch(LoadingScreenActions.setPercentage(percentage));
  }, [percentage]);

  useEffect(() => {
    if (destinationPoi) {
      console.log(destinationPoi);
      resetMapAndWayFinding(true, false, false, true);
      const places = ACA.getPlacesFromPoi(destinationPoi.id);
      if (places && places.length > 0) {
        const object =
          places[0].shape_id && awm.objectManager.getSpace(places[0].shape_id);
        setDestinationObject(object);
        // setCurrentFloor(
        //   parseInt(awm.objectManager.getFloor(places[0].floor_id).id)
        // );
        // selectionController.selectPlace(places[0], true, true, '#fff');
        // setCurrentPlace(places);
      }
    }

    console.log(destinationPoi, "destinationPoi");
  }, [destinationPoi]);

  // useEffect(() => {
  //   if (destinationSearch) {
  //     setDestinationSearchResult(searchPoi(destinationSearch));
  //   } else {
  //     setDestinationSearchResult(null);
  //   }
  // }, [destinationSearch]);

  // useEffect(() => {
  //   if (sourceSearch) {
  //     console.log(sourceSearch);
  //     setSourceSearchResult(searchPoi(sourceSearch));
  //   } else {
  //     setSourceSearchResult(null);
  //   }
  // }, [sourceSearch]);

  // useEffect(() => {
  //   if (sourcePoi) {
  //     setIsSourceChanged(true);
  //     resetMapAndWayFinding(true, false, false, true);
  //     const places = ACA.getPlacesFromPoi(sourcePoi.id);
  //     if (places && places.length > 0) {
  //       const object =
  //         places[0].shape_id && awm.objectManager.getSpace(places[0].shape_id);
  //       const floor = awm.objectManager.getFloor(object.parent.id);
  //       const objectPosition = object._mesh.position;
  //       awm.wayfindingManager.setUserAdsumPosition(
  //         objectPosition,
  //         floor,
  //         false
  //       );
  //       awm.wayfindingManager._doAdsumUserPositionUpdate(objectPosition, floor);
  //       awm.objectManager.user.setDisplayMode("hide");
  //       destinationPoi &&
  //         selectionController.selectPlace(
  //           ACA.getPlacesFromPoi(destinationPoi.id) &&
  //             ACA.getPlacesFromPoi(destinationPoi.id).length > 0 &&
  //             ACA.getPlacesFromPoi(destinationPoi.id)[0]
  //         );
  //       selectionController.selectPlace(places[0]);
  //       //
  //     }
  //   }
  // }, [sourcePoi]);

  useEffect(() => {
    if (selectedObject) {
      const object = selectedObject;
      if (isActionEnabled) {
        const pois = ACA.getPoisFromPlace(object.placeId);
        const place = ACA.getPlace(object.placeId);
        if (pois && pois.length > 0) {
          if (Array.from(pois[0].categories.values).length > 0) {
            const categoryId = Array.from(pois[0].categories.values)[0].value;
            const checkCategory = ACA.getCategoriesBy({ id: categoryId });
            const isAmenities = checkCategory[0].name === "Amenities";
            if (!isAmenities) {
              const poiPlaces = pois.map((poi) => {
                const places = Array.from(poi.places.values).map((place) =>
                  ACA.getPlace(place.value),
                );
                return {
                  ...poi,
                  places,
                  placeId: object.placeId,
                };
              });
              console.log(
                "map clicked on poi",
                poiPlaces[0] && poiPlaces[0].name,
              );
              if (!destinationObject || sourceObject) {
                setDestinationObject(object);
                setDestinationPoi(poiPlaces[0]);
              } else {
                setSourceObject(object);
                // setSourcePoi(poiPlaces[0]);
              }
              // setSelectedFrom(poiPlaces[0]);
              // setCurrentPlace(place);
              // setSelectedObject(object);
              // setCurrentFloor(awm.objectManager.getFloor(place.floor_id));
              selectionController.selectPlace(place, true, true, "#fff");
            }
          } else {
            if (object.placeId) {
              // setSelectedObject(object);
              // setCurrentFloor(awm.objectManager.getFloor(place.floor_id));
              // selectionController.selectPlace(place);
              // setCurrentPlace(place);
              // setIsAmenities(true);
              // setIsLevel(false);
              // setModalLevel(true);
              // setModalCategory(false);
              // setModalSearch(false);
            }
            // MainActions.zoomAction(-350);
            // setSelectedFrom(pois[0]);
          }
        }
      }
      // awm.cameraManager.centerOn(object, true, {
      //   zoom: true,
      //   maxDistance: 200,
      //   minDistance: 200,
      // });
    }
  }, [selectedObject]);

  // const searchPoi = (search) => {
  //   return allPois.filter((poi) =>
  //     poi.name.toLowerCase().includes(search.toLowerCase())
  //   );
  // };

  useEffect(() => {
    if (configLoaded && !mapLoaded && mapState === "idle") {
      const poi_id = urlParams.get("poi_id");
      const findPoi = allPois.find((x) => x.id === parseInt(poi_id, 0));
      const x = urlParams.get("x");
      const y = urlParams.get("y");
      const z = urlParams.get("z");
      const floor_id = urlParams.get("floor_id");
      setUserFloor(parseInt(floor_id, 0));

      if (findPoi) {
        setSelectedFrom({
          name: "QR Code URL",
          shape_id: null,
        });
        handleClickPoi(findPoi);
        const updateUserPosition = async () => {
          const floor = await awm.objectManager.getFloor(parseInt(floor_id, 0));

          await awm.wayfindingManager.setUserAdsumPosition(
            {
              x: parseInt(x, 0),
              y: parseInt(y, 0),
              z: parseInt(z, 0),
            },
            floor,
            false,
          );
          await awm.wayfindingManager._doAdsumUserPositionUpdate(
            {
              x: parseInt(x, 0),
              y: parseInt(y, 0),
              z: parseInt(z, 0),
            },
            floor,
          );
          await awm.objectManager.user.setDisplayMode("visible");
          // await awm.sceneManager.setCurrentFloor(floor, true);
          // await awm.cameraManager.centerOn(awm.objectManager.user, true, {
          //   zoom: true,
          //   maxDistance: 200,
          //   minDistance: 200,
          // });
        };

        updateUserPosition();
      }
    }
  }, [urlParams, allPois, mapLoaded]);

  const initDevice = () => {
    deviceConfig
      .init()
      .then(() => {
        setPercentage(10);
      })
      .then(() => ACA.init(deviceConfig.config.api))
      .then(() => {
        setPercentage(25);
      })
      .then(() => ACA.load(false, false))
      .then(() => {
        setPercentage(45);
      })
      .then(() => {
        setPercentage(65);
        // console.log("isMobile", isMobile);
        const awMap: AdsumWebMap = new AdsumWebMap({
          loader: new AdsumLoader({
            entityManager: ACA.entityManager, // Give it in order to be used to consume REST API
            deviceId: deviceConfig.config.map.deviceId, // The device Id to use
            wireframeSpaces: true,
            wireframeSpacesOptions: { color: 0x5a5b5a },
          }), // The loader to use
          camera: {
            centerOnOptions: {
              fitRatio: 3,
              minDistance: 100,
              altitude: 40,
            },
          },
          engine: {
            container: awmContainerRef.current, // The div DOMElement to insert the canvas into
          },
          wayfinding: {
            pathBuilder: new DotPathBuilder(
              new DotPathBuilderOptions({
                patternSpace: 4, // 4,
                patternSize: 2, // 2
                pattern: new ArrowPathPatternOptions({
                  color: "#be272f",
                }),
              }),
              new DotPathSectionDrawerOptions({
                center: true,
                centerOnOptions: {
                  fitRatio: 3,
                  minDistance: 20,
                  altitude: 40,
                },
                oriented: true,
                speed: 10,
              }),
            ),
            userObject: new PinUserObject({
              color: "#be272f",
              size: 8,
            }),
            pathSectionDrawer: new DotPathSectionDrawer({
              center: true,
              oriented: true,
              speed: 10,
            }),
          },
          scene: {
            animation: new SingleFloorAnimation({
              keepSiteVisible: false,
              bounce: true,
              center: true,
              centerOnOptions: {
                fitRatio: 1.15,
                minDistance: 20,
              },
            }),
          },
        });
        setAwm(awMap);
        showArrivedLabel(true);
        setConfigLoaded(true);
        setPercentage(90);
        setAllPois(
          ACA.getAllPois().map((poi) => {
            const allPlaces = Array.from(poi.places.values).map((place) =>
              ACA.getPlace(place.value),
            );

            const places = _.sortBy(allPlaces, (x) => {
              return x.name.split("-")[1];
            })
              .map((place, index) => {
                if (index === 0) {
                  return place.name;
                } else {
                  const placeNameSplit = place.name.split("-");
                  return placeNameSplit[1]
                    ? placeNameSplit[1]
                    : placeNameSplit[0];
                }
              })
              .join("/")
              .replace(/_/g, " ");

            const floor_id =
              allPlaces.length > 0 ? allPlaces[0].floor_id : null;

            const shape_id =
              allPlaces.length > 0 ? allPlaces[0].shape_id : null;

            const place_id = allPlaces.length > 0 ? allPlaces[0].id : null;

            const tags =
              Array.from(poi.tags.values).length > 0
                ? ACA.getTagBy({
                    id: Array.from(poi.tags.values)[0].value,
                  })[0].name
                : null;

            return { ...poi, places, tags, floor_id, shape_id, place_id };
          }),
        );
      })
      .catch((err) => {
        console.error(err);
      });
  };

  // const onLevelChanged = (e) => {
  //   const id = e.target.id
  //     ? e.target.id
  //     : e.target.parentNode.id
  //     ? e.target.parentNode.id
  //     : e.target.parentNode.parentNode.id
  //     ? e.target.parentNode.parentNode.id
  //     : currentFloor;
  //   console.log(id);
  //   changeFloor(parseInt(id, 10));
  //   // setCurrentFloor(parseInt(id));
  //   resetMapAndWayFinding(true, false, false, true);
  // };

  const loadMap = () => {
    if (configLoaded && !mapLoaded && mapState === "idle") {
      setDefaultFloor(awm.defaultFloor);
      setPercentage(100);
      // eslint-disable-next-line react/no-did-update-set-state
      // setCurrentFloor(parseInt(awm.defaultFloor.id));
      const floors = Array.from(awm.objectManager.floors);
      setAllFloors(
        _.orderBy(
          floors.map((floor) => floor[1]),
          (level) => level.name,
          "desc",
        ),
      );
      setMapLoaded(true);
      awm.objectManager.user.setDisplayMode("none");
      MainActions.zoomAction(840);
      setTimeout(() => {
        setIsLoadingFinish(true);
      }, 1000);
    }
  };

  const isMapOpen = () => {
    // eslint-disable-line class-methods-use-this
    return true;
  };

  const tmtt = (poi, poiPlace, pmr) => {
    dispatch(WayFindingControlsActions.tmtt(poi, poiPlace, pmr));
  };
  const resetMapAndWayFinding = (
    reset,
    resetMap,
    resetMapAnimatedOption,
    resetWayfinding,
  ) => {
    dispatch(
      WayFindingControlsActions.resetMapAndWayFinding(
        reset,
        resetMap,
        resetMapAnimatedOption,
        resetWayfinding,
      ),
    );
  };

  const changeFloor = (floorId) =>
    dispatch(MainActions.changeFloorAction(floorId));

  const wayfindingStart = () => {
    dispatch(WayFindingControlsActions.finish(false));
  };
  const showArrivedLabel = (value) => {
    dispatch(WayFindingControlsActions.showArrivedLabel(value));
  };

  const highlightMultiplePlaces = (poi) => {
    dispatch(
      SelectionActions.selectPoiAction(
        ACA.getPoi(poi),
        true,
        true,
        {
          zoom: true,
          maxDistance: 200,
          minDistance: 200,
        },
        true,
        null,
        true,
        "#fff",
      ),
    );
  };

  const onMapClicked = (object) => {
    if (object && object.placeId) {
      setSelectedObject(object);
      const pois = ACA.getPoisFromPlace(object.placeId);
      const poi = pois[0];
      console.log(poi, "poi");
      if (poi) {
        const places = ACA.getPlace(object.placeId);
        const tags =
          Array.from(poi.tags.values).length > 0
            ? ACA.getTagBy({
                id: Array.from(poi.tags.values)[0].value,
              })[0].name
            : null;
        setSelectedObject(object);
        setSelectedPoi({
          ...poi,
          places: places.name,
          tags,
          floor_id: places.floor_id,
          shape_id: places.shape_id,
        });
      }
    }
  };

  useEffect(() => {
    if (!wayfindingState.drawing && wayFindingControlsState.finish) {
      setIsActionEnabled(true);
      if (selectedPoi) {
        handleCenterPoi();
      }
    }
    if (
      wayfindingState.drawing &&
      wayFindingControlsState.finish &&
      isActionEnabled
    ) {
      setIsActionEnabled(false);
    }
  }, [wayFindingControlsState, wayfindingState]);

  console.log(
    isActionEnabled,
    wayfindingState.drawing,
    wayFindingControlsState.finish,
    "isActionEnabled",
    "wayfindingState.drawing",
    " wayFindingControlsState.finish",
  );

  const onTakeMeThere = async (viaLift) => {
    if (isActionEnabled) {
      setLoading(true);
      setTimeout(() => {
        PlacesController.sortAllAdsumPlaces();
      }, 1000);

      // setIsSourceChanged(false);
      resetMapAndWayFinding(true, false, true, true);
      setTimeout(async () => {
        if (checkComputedPath(destinationObject)) {
          setIsActionEnabled(false);
          wayfindingStart();
          if (getPoi(destinationObject) && getPlace(destinationObject))
            await awm.cameraManager.zoom(-450);
          tmtt(
            getPoi(destinationObject)[0],
            [getPlace(destinationObject)],
            viaLift,
          );
        } else {
          resetAll();
        }
        setLoading(false);
      }, 2000);
    }
  };

  const resetAll = () => {
    resetMapAndWayFinding(true, true, true, true);
    // setCurrentFloor(defaultFloor);
  };

  // console.log(histories, isHistoryOpen);

  const renderMap = (): Map => {
    return (
      <Map
        store={store}
        awm={awm}
        isOpen={isMapOpen()}
        className={`app-map-container ${
          isActionEnabled
            ? "app-map-container-has-padding"
            : "app-map-container-no-padding"
        } ${selectedPoi ? "app-map-container-has-bottom-padding" : ""} `}
        onClick={onMapClicked}
        backgroundImage={mapBackground}
        getDrawPathSectionOptions={getDrawPathSectionOptions}
        highlightColor="#fff"
      >
        <WayFindingControls
          awm={awm}
          kioskPlace={defaultFloor}
          selectedPoi={selectedPoi}
          arrivalLabelStyle={labelStyle.arrival}
          interchangeLabelStyle={labelStyle.interchange}
          icLabelText=" Go "
          customResetFunction={() => {}}
          destinationLabelText="You've reached "
        />
        <div id="adsum-web-map-container" ref={awmContainerRef} />
      </Map>
    );
  };

  // const onSearchResultClicked = (poi, type) => {
  //   setIsShowSearchResult(false);
  //   if (type === "destination") {
  //     setDestinationPoi(poi);
  //     setDestinationSearchResult(null);
  //   } else {
  //     setSourcePoi(poi);
  //     setSourceSearchResult(null);
  //   }
  // };

  const checkTags = (name) => {
    let color;
    if (name === "West" || name === "Convention Centre") {
      color = "green";
    } else if (name === "East" || name === "Tower 3" || name === "Tower 4") {
      color = "red";
    } else if (name === "North" || name === "Tower 1" || name === "Tower 2") {
      color = "orange";
    } else if (name === "Fountain Court") {
      color = "blue";
    } else if (
      name === "Purple" ||
      name === "Tower 5" ||
      name === "Sky Garden"
    ) {
      color = "purple";
    } else {
      color = "dark-orange";
    }
    return color;
  };

  const filteredPois =
    allPois.length > 0 &&
    _.orderBy(allPois, "name")
      .filter((poi) => {
        if (keyword.from) {
          return poi.name.toLowerCase().includes(keyword.from.toLowerCase());
        } else {
          return true;
        }
      })
      .filter((poi) => {
        if (keyword.to) {
          return poi.name.toLowerCase().includes(keyword.to.toLowerCase());
        } else {
          return true;
        }
      })
      .filter((poi) => {
        const parkingCategories = ACA.getCategoriesBy({
          name: "Carpark",
        });

        const poiCategories = _.map(Array.from(poi.categories.values), "value");

        return parkingCategories.length > 0
          ? !poiCategories.includes(parkingCategories[0].id)
          : true;

        // return !_.map(Array.from(poi.categories.values), "value").include(
        //   parkingCategories[0].id
        // );
      });

  // console.log(filteredPois, "filteredPois");

  // const handleDeleteHistory = (index) => {
  //   const filterHistory = histories.filter((_, i) => i !== index);
  //   localStorage.setItem("histories", JSON.stringify(filterHistory));
  //   setHistories(filterHistory);
  // };

  // const handleDeleteHistoryPoi = (index) => {
  //   const filterHistory = historiesPois.filter((_, i) => i !== index);
  //   localStorage.setItem("historiesPois", JSON.stringify(filterHistory));
  //   setHistories(filterHistory);
  // };

  const handleClickFrom = (poi) => {
    setLoading(true);
    console.log("I am clicked");
    setIsHistoryOpen(true);
    const findHistory = histories.find((x) => x === poi.name);
    if (!findHistory) {
      setHistories([...histories, poi.name]);
      localStorage.setItem(
        "histories",
        JSON.stringify([...histories, poi.name]),
      );
    } else {
      const deleteHistory = histories.filter((x) => x !== poi.name);
      setHistories([...deleteHistory, poi.name]);
      localStorage.setItem(
        "histories",
        JSON.stringify([...deleteHistory, poi.name]),
      );
    }
    setSelectedFrom(poi);
    setIsFormModalOpen(false);
    setKeyword({
      ...keyword,
      from: "",
    });
    setUserFloor(poi.floor_id);
    handleUpdateUser(poi.floor_id, poi.shape_id);
    resetMapAndWayFinding(true, false, true, true);
  };

  const handleClickPoi = async (poi) => {
    console.log("I am clicked", poi);
    setIsHistoryPoiOpen(true);
    const findHistory = historiesPois.find((x) => x === poi.name);
    if (!findHistory) {
      setHistoriesPois([...historiesPois, poi.name]);
      localStorage.setItem(
        "historiesPois",
        JSON.stringify([...historiesPois, poi.name]),
      );
    } else {
      const deleteHistory = historiesPois.filter((x) => x !== poi.name);
      setHistories([...deleteHistory, poi.name]);
      localStorage.setItem(
        "historiesPois",
        JSON.stringify([...deleteHistory, poi.name]),
      );
    }
    setSelectedPoi(poi);
    setIsFormModalPoiOpen(false);
    setKeyword({
      ...keyword,
      to: "",
    });
    handleUpdatePoiPosition(poi.floor_id, poi.shape_id, poi.place_id);
    highlightMultiplePlaces(poi);
    setDestinationPoi(poi);
  };

  const handleUpdateUser = async (floor_id, shape_id) => {
    // if (floor_id !== currentFloor) {

    // }
    const object = awm.objectManager.getSpace(shape_id);
    const updateUserPosition = async () => {
      const floor = await awm.objectManager.getFloor(floor_id);
      const objectPosition = object._mesh.position;

      await awm.wayfindingManager.setUserAdsumPosition(
        { ...objectPosition, z: 25 },
        floor,
        false,
      );
      await awm.wayfindingManager._doAdsumUserPositionUpdate(
        { ...objectPosition, z: 25 },
        floor,
      );
      await awm.objectManager.user.setDisplayMode("visible");
      // await awm.cameraManager.centerOn(object, true, {
      //   zoom: true,
      //   maxDistance: 200,
      //   minDistance: 200,
      // });
      setLoading(false);
      await awm.sceneManager.setCurrentFloor(floor, true);
      await awm.cameraManager.centerOn(object, true, {
        zoom: true,
        maxDistance: 200,
        minDistance: 200,
      });
    };
    // console.log(awm.objectManager.user);

    updateUserPosition();
  };

  const handleUpdatePoiPosition = async (floor_id, shape_id, place_id) => {
    const object = awm.objectManager.getSpace(shape_id);
    // const floor = await awm.objectManager.getFloor(parseInt(floor_id));
    const places = ACA.getPlace(place_id);
    console.log(places, "places");
    setSelectedObject(object);
    // setCurrentFloor(awm.objectManager.getFloor(floor_id));
    // selectionController.selectPlace(places);
  };

  const handleChangeKeyword = (name, value) => {
    setKeyword({
      ...keyword,
      [name]: value,
    });
  };

  const handleClickHistory = (name, value) => {
    handleChangeKeyword(name, value);
    setIsHistoryOpen(false);
  };

  const handleClickHistoryPoi = (name, value) => {
    handleChangeKeyword(name, value);
    setIsHistoryPoiOpen(false);
  };

  const handleCenter = async () => {
    if (awm.objectManager.user) {
      await awm.cameraManager.centerOn(awm.objectManager.user, true, {
        zoom: true,
        maxDistance: 200,
        minDistance: 200,
      });
    }
  };

  const handleCenterPoi = async () => {
    const object = await awm.objectManager.getSpace(selectedPoi.shape_id);
    await awm.cameraManager.centerOn(object, true, {
      zoom: true,
      maxDistance: 200,
      minDistance: 200,
    });
  };

  const handleClose = () => {
    setIsFormModalOpen(false);
    setIsHistoryOpen(true);
    // setSelectedFrom(null);
  };

  const handleClosePoi = async () => {
    setIsFormModalPoiOpen(false);
    setIsHistoryPoiOpen(true);
    // setSelectedPoi(null);
    // const floor = await awm.objectManager.getFloor(
    //   userFloor ? userFloor : defaultFloor.id
    // );
    // await awm.sceneManager.setCurrentFloor(floor, true);
    // handleCenter();
  };

  const handleClearPoi = async () => {
    setSelectedPoi(null);
    let floor_id;
    if (selectedFrom) {
      floor_id = selectedFrom.floor_id;
    } else {
      floor_id = awm.defaultFloor.id;
    }

    const floor = await awm.objectManager.getFloor(parseInt(floor_id, 0));
    await awm.sceneManager.setCurrentFloor(floor, true);
    await awm.cameraManager.centerOn(awm.objectManager.user, true, {
      zoom: true,
      maxDistance: 200,
      minDistance: 200,
    });

    resetMapAndWayFinding(true, false, true, true);
  };

  console.log(userFloor, selectedPoi, "userFloor");

  return (
    <div className="App">
      <div
        className="bg-app"
        style={{ height: isActionEnabled ? "150px" : "85px" }}
      />
      {console.log(currentFloor, "currentFloor")}
      <div
        className="loading-progress"
        style={{ display: loading ? "flex" : "none" }}
      >
        <div className="loader" />
        <p>Routing...</p>
      </div>

      {!isLoadingFinish && (
        <div className="loading">
          <img src={require("./assets/logo-white.png")} alt="" />
          <p>Welcome to Suntec City</p>
          <div className="loading-bar-wrapper">
            <div className="loading-bar" style={{ width: `${percentage}%` }} />
            <span className="loading-text">{percentage}%</span>
          </div>
        </div>
      )}

      <div className="navigation-logo">
        <img
          src={require("./assets/logo-suntec-white.png")}
          alt=""
          onClick={handleCenter}
        />
        <p className="navigation-logo-text">Suntec City QuickGuide</p>
      </div>
      <div className="navigation">
        {isActionEnabled && (
          <div className="navigation-card">
            <div className="point">
              <div className="from-point" />
              <div className="to-point" />
            </div>
            <div className="navigation-wrapper">
              <div className="navigation-input">
                <label>From</label>
                <div className="navigation-input-label">
                  <span onClick={() => setIsFormModalOpen(true)}>
                    {selectedFrom ? selectedFrom.name : "Where are you at?"}
                  </span>
                </div>
              </div>
              <div className="navigation-input">
                <label>To</label>
                <div className="navigation-input-label">
                  <span onClick={() => setIsFormModalPoiOpen(true)}>
                    {selectedPoi ? selectedPoi.name : "Where are you going to?"}
                  </span>
                  {selectedPoi && (
                    <i className="icon-close" onClick={handleClearPoi} />
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {isActionEnabled && (
        <div className="map-control-wrapper">
          <div className="level-control-wrapper">
            <div className="level-title">Level</div>
            <div className="levels-container">
              {_.sortBy(
                allFloors.map((x) => {
                  const nameSplitted = x.name.match(/.{1,1}/g);
                  const orderNumber =
                    nameSplitted[0] === "B"
                      ? parseInt(-nameSplitted[1], 0)
                      : parseInt(nameSplitted[1], 0);
                  return {
                    ...x,
                    order_number: orderNumber,
                  };
                }),
                "order_number",
              )
                .reverse()
                .map((floor) => {
                  const nameSplitted = floor.name.match(/.{1,1}/g);
                  return (
                    <div
                      className="level-btn-wrapper"
                      key={floor.id}
                      onClick={() => changeFloor(floor.id)}
                    >
                      <div
                        className={
                          floor.id === currentFloor
                            ? "level-btn-active"
                            : "level-btn"
                        }
                      >
                        {nameSplitted[0]}
                        <sup>{nameSplitted[1]}</sup>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      )}

      {isActionEnabled && (
        <div
          className={`modal-popup-bottom  ${
            selectedPoi
              ? "modal-popup-bottom-is-open"
              : "modal-popup-bottom-is-close"
          }`}
        >
          {selectedPoi && (
            <Fragment>
              <img
                src={
                  Array.from(selectedPoi.logos.values).length > 0
                    ? Array.from(selectedPoi.logos.values)[0].uri
                    : require("./assets/default.png")
                }
                alt={selectedPoi.name}
              />
              <div className="modal-popup-bottom-content">
                <h1 className="poi-title">
                  {selectedPoi.name.length > 40
                    ? `${selectedPoi.name.substr(0, 40)}...`
                    : selectedPoi.name}
                </h1>
                <div
                  className={`poi-detail-subtitle ${checkTags(
                    selectedPoi.tags,
                  )}`}
                >
                  {/* {selectedPoi.tags && (
                    <h2 className={checkTags(selectedPoi.tags)}>
                      {selectedPoi.tags}
                    </h2>
                  )} */}
                  <h2>
                    {selectedPoi.places === "Space"
                      ? awm.objectManager.getFloor(selectedPoi.floor_id).name
                      : selectedPoi.places.replace(/_/g, " ")}
                  </h2>
                </div>
                <p className="poi-detail-description">
                  {selectedPoi.description &&
                    selectedPoi.description.split("\n").map((item, index) => {
                      return (
                        <span key={index}>
                          {item}
                          <br />
                        </span>
                      );
                    })}
                </p>
              </div>
              <div className="poi-details-button">
                <button
                  className="button-left"
                  onClick={() => onTakeMeThere(false)}
                >
                  Get Direction
                  <svg
                    width="10"
                    height="16"
                    viewBox="0 0 16 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.77553 13.9609L11.3425 17.1649C11.4594 17.2706 11.5527 17.3996 11.6165 17.5435C11.6804 17.6875 11.7132 17.8433 11.713 18.0008V22.1258C11.713 22.4242 11.5945 22.7103 11.3835 22.9213C11.1725 23.1323 10.8864 23.2508 10.588 23.2508V23.2508C10.2897 23.2508 10.0035 23.1323 9.79254 22.9213C9.58156 22.7103 9.46303 22.4242 9.46303 22.1258V18.5018L6.87891 17.0134"
                      fill="white"
                    />
                    <path
                      d="M8.52344 5.625C9.86963 5.625 10.9609 4.53369 10.9609 3.1875C10.9609 1.84131 9.86963 0.75 8.52344 0.75C7.17724 0.75 6.08594 1.84131 6.08594 3.1875C6.08594 4.53369 7.17724 5.625 8.52344 5.625Z"
                      fill="white"
                    />
                    <path
                      d="M4.77059 10.3816L3.46221 10.5005L2.70359 12.776C2.65549 12.9204 2.57942 13.0539 2.47972 13.1689C2.38002 13.2839 2.25864 13.3781 2.12252 13.4462C1.98639 13.5143 1.83819 13.5549 1.68637 13.5656C1.53455 13.5764 1.3821 13.5572 1.23771 13.5091V13.5091C1.08913 13.4596 0.952128 13.3804 0.834982 13.2765C0.717837 13.1725 0.622979 13.0459 0.556139 12.9043C0.4893 12.7627 0.451866 12.6089 0.446098 12.4524C0.440331 12.2959 0.466351 12.1399 0.522585 11.9937L1.74359 8.81933C1.81074 8.64479 1.92036 8.48975 2.0625 8.36822C2.20465 8.2467 2.37485 8.16253 2.55771 8.12333L6.58034 7.17383"
                      fill="white"
                    />
                    <path
                      d="M15.8034 10.602C15.7676 10.4587 15.7039 10.3238 15.616 10.2051C15.528 10.0864 15.4176 9.98613 15.2909 9.91012C15.1642 9.8341 15.0238 9.78378 14.8776 9.76203C14.7315 9.74028 14.5825 9.74753 14.4392 9.78336L11.8431 10.4325L8.2562 7.53561C7.96512 7.31775 7.62155 7.18084 7.26041 7.13881C6.89927 7.09677 6.53345 7.15111 6.20011 7.29629C5.86678 7.44147 5.57783 7.67232 5.36264 7.96537C5.14745 8.25842 5.01368 8.60323 4.97494 8.96473L3.10632 21.9375C3.05765 22.2182 3.11773 22.5069 3.27434 22.7449C3.43095 22.9829 3.67233 23.1522 3.94939 23.2186C4.22644 23.2849 4.51837 23.2433 4.76579 23.102C5.01322 22.9608 5.19756 22.7307 5.28132 22.4584L8.6312 11.0325L11.0469 12.495C11.2162 12.5972 11.404 12.6649 11.5995 12.6942C11.795 12.7236 11.9944 12.714 12.1862 12.666L14.9844 11.9662C15.1278 11.9304 15.2627 11.8668 15.3815 11.7788C15.5002 11.6909 15.6005 11.5804 15.6765 11.4538C15.7526 11.3271 15.803 11.1866 15.8247 11.0405C15.8465 10.8943 15.8393 10.7453 15.8034 10.602Z"
                      fill="white"
                    />
                  </svg>
                </button>
                {userFloor !== selectedPoi.floor_id && (
                  <button
                    className="button-right"
                    onClick={() => onTakeMeThere(true)}
                  >
                    With Lift Access
                    <svg
                      width="10"
                      height="16"
                      viewBox="0 0 18 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3.54266 13.5586C3.40237 13.5596 3.26368 13.5869 3.13461 13.6388C3.00554 13.6907 2.88864 13.7663 2.79068 13.8611C2.69272 13.956 2.61563 14.0682 2.56386 14.1913C2.5121 14.3144 2.4867 14.446 2.48911 14.5785V16.9834C2.48577 17.0296 2.49254 17.0761 2.509 17.1198C2.52545 17.1635 2.55124 17.2035 2.58477 17.2374C2.6183 17.2713 2.65885 17.2983 2.7039 17.3168C2.74895 17.3352 2.79754 17.3448 2.84666 17.3448C2.89577 17.3448 2.94436 17.3352 2.98941 17.3168C3.03446 17.2983 3.07501 17.2713 3.10854 17.2374C3.14207 17.2035 3.16786 17.1635 3.18432 17.1198C3.20077 17.0761 3.20754 17.0296 3.2042 16.9834V14.79H3.37011V20.9001C3.37011 21.5267 4.33075 21.5064 4.33075 20.9001V17.3124H4.49667V20.8875C4.49667 21.4938 5.45565 21.5142 5.45399 20.8875V14.7775H5.61991V16.9708C5.61657 17.0169 5.6233 17.0631 5.63968 17.1066C5.65606 17.1501 5.68173 17.19 5.7151 17.2237C5.74847 17.2574 5.78884 17.2843 5.83368 17.3027C5.87853 17.3211 5.9269 17.3306 5.97579 17.3306C6.02468 17.3306 6.07305 17.3211 6.1179 17.3027C6.16275 17.2843 6.20311 17.2574 6.23648 17.2237C6.26985 17.19 6.29553 17.1501 6.3119 17.1066C6.32828 17.0631 6.33501 17.0169 6.33168 16.9708V14.591C6.33478 14.3212 6.22434 14.0613 6.02463 13.8683C5.82491 13.6753 5.55225 13.565 5.26651 13.5617L3.54266 13.5586Z"
                        fill="white"
                      />
                      <path
                        d="M4.4116 13.3421C4.57567 13.3421 4.73606 13.2961 4.87249 13.2101C5.00891 13.124 5.11524 13.0016 5.17802 12.8585C5.24081 12.7154 5.25724 12.5579 5.22523 12.4059C5.19322 12.254 5.11421 12.1144 4.9982 12.0048C4.88218 11.8953 4.73436 11.8207 4.57344 11.7904C4.41252 11.7602 4.24572 11.7757 4.09414 11.835C3.94255 11.8943 3.81299 11.9947 3.72184 12.1235C3.63068 12.2524 3.58203 12.4038 3.58203 12.5587C3.58203 12.7665 3.66943 12.9657 3.82501 13.1126C3.98058 13.2595 4.19159 13.3421 4.4116 13.3421Z"
                        fill="white"
                      />
                      <path
                        d="M8.2056 13.5586C8.06595 13.5604 7.92805 13.5883 7.79984 13.6406C7.67162 13.6929 7.55562 13.7686 7.45849 13.8634C7.36136 13.9582 7.28502 14.0701 7.23386 14.1929C7.18269 14.3156 7.15771 14.4466 7.16035 14.5785V16.9834C7.16035 17.0727 7.19793 17.1584 7.26482 17.2215C7.33172 17.2847 7.42245 17.3202 7.51706 17.3202C7.61167 17.3202 7.7024 17.2847 7.76929 17.2215C7.83619 17.1584 7.87377 17.0727 7.87377 16.9834V14.79H8.03969V20.9001C8.03969 21.5267 8.99867 21.5064 8.99867 20.9001V17.3124H9.16458V20.8875C9.16074 20.9491 9.17027 21.0108 9.19259 21.0688C9.21491 21.1268 9.24954 21.1799 9.29437 21.2248C9.33919 21.2696 9.39326 21.3054 9.45326 21.3299C9.51325 21.3543 9.5779 21.3669 9.64325 21.3669C9.70859 21.3669 9.77324 21.3543 9.83323 21.3299C9.89323 21.3054 9.9473 21.2696 9.99212 21.2248C10.0369 21.1799 10.0716 21.1268 10.0939 21.0688C10.1162 21.0108 10.1257 20.9491 10.1219 20.8875V14.7775H10.2878V16.9708C10.2878 17.0597 10.3252 17.145 10.3918 17.2079C10.4584 17.2708 10.5487 17.3061 10.6429 17.3061C10.737 17.3061 10.8274 17.2708 10.8939 17.2079C10.9605 17.145 10.9979 17.0597 10.9979 16.9708V14.591C10.9999 14.4575 10.9739 14.3248 10.9215 14.2007C10.8691 14.0766 10.7913 13.9635 10.6925 13.8679C10.5937 13.7723 10.4758 13.696 10.3458 13.6435C10.2157 13.5909 10.0759 13.5632 9.93442 13.5617L8.2056 13.5586Z"
                        fill="white"
                      />
                      <path
                        d="M9.07566 13.3421C9.23974 13.3421 9.40013 13.2961 9.53655 13.2101C9.67297 13.124 9.7793 13.0016 9.84209 12.8585C9.90488 12.7154 9.9213 12.5579 9.88929 12.4059C9.85728 12.254 9.77828 12.1144 9.66226 12.0048C9.54624 11.8953 9.39843 11.8207 9.23751 11.7904C9.07658 11.7602 8.90979 11.7757 8.7582 11.835C8.60662 11.8943 8.47706 11.9947 8.3859 12.1235C8.29475 12.2524 8.24609 12.4038 8.24609 12.5587C8.24609 12.7665 8.33349 12.9657 8.48907 13.1126C8.64464 13.2595 8.85565 13.3421 9.07566 13.3421Z"
                        fill="white"
                      />
                      <path
                        d="M12.8618 13.5586C12.7222 13.5606 12.5844 13.5886 12.4563 13.641C12.3282 13.6934 12.2123 13.7691 12.1152 13.8639C12.0181 13.9586 11.9418 14.0705 11.8905 14.1931C11.8393 14.3157 11.8141 14.4467 11.8166 14.5785V16.9834C11.8166 17.0276 11.8258 17.0714 11.8437 17.1123C11.8616 17.1531 11.8879 17.1903 11.921 17.2215C11.9542 17.2528 11.9935 17.2776 12.0368 17.2946C12.08 17.3115 12.1264 17.3202 12.1733 17.3202C12.2201 17.3202 12.2665 17.3115 12.3098 17.2946C12.3531 17.2776 12.3924 17.2528 12.4255 17.2215C12.4586 17.1903 12.4849 17.1531 12.5028 17.1123C12.5208 17.0714 12.53 17.0276 12.53 16.9834V14.79H12.6959V20.9001C12.6959 21.5267 13.6549 21.5064 13.6549 20.9001V17.3124H13.8208V20.8875C13.817 20.9491 13.8265 21.0108 13.8488 21.0688C13.8711 21.1268 13.9058 21.1799 13.9506 21.2248C13.9954 21.2696 14.0495 21.3054 14.1095 21.3299C14.1695 21.3543 14.2341 21.3669 14.2995 21.3669C14.3648 21.3669 14.4295 21.3543 14.4895 21.3299C14.5494 21.3054 14.6035 21.2696 14.6483 21.2248C14.6932 21.1799 14.7278 21.1268 14.7501 21.0688C14.7724 21.0108 14.782 20.9491 14.7781 20.8875V14.7775H14.944V16.9708C14.9407 17.0167 14.9474 17.0627 14.9637 17.106C14.98 17.1493 15.0056 17.189 15.0388 17.2226C15.072 17.2561 15.1122 17.2829 15.1568 17.3012C15.2014 17.3196 15.2496 17.329 15.2983 17.329C15.3469 17.329 15.3951 17.3196 15.4397 17.3012C15.4844 17.2829 15.5245 17.2561 15.5578 17.2226C15.591 17.189 15.6165 17.1493 15.6328 17.106C15.6491 17.0627 15.6558 17.0167 15.6525 16.9708V14.591C15.6565 14.3228 15.5479 14.0641 15.3505 13.8712C15.1531 13.6783 14.8829 13.5671 14.5989 13.5617L12.8618 13.5586Z"
                        fill="white"
                      />
                      <path
                        d="M13.7358 13.3421C13.8999 13.3421 14.0603 13.2961 14.1967 13.2101C14.3331 13.124 14.4395 13.0016 14.5022 12.8585C14.565 12.7154 14.5815 12.5579 14.5494 12.4059C14.5174 12.254 14.4384 12.1144 14.3224 12.0048C14.2064 11.8953 14.0586 11.8207 13.8977 11.7904C13.7367 11.7602 13.5699 11.7757 13.4184 11.835C13.2668 11.8943 13.1372 11.9947 13.0461 12.1235C12.9549 12.2524 12.9062 12.4038 12.9062 12.5587C12.9062 12.7665 12.9937 12.9657 13.1492 13.1126C13.3048 13.2595 13.5158 13.3421 13.7358 13.3421"
                        fill="white"
                      />
                      <path
                        d="M12.4536 5.53979L10.0312 3.25557L10.6368 2.67433L12.6328 4.56218V0H13.4889V4.56218L15.4915 2.67433L16.0971 3.25557L13.6697 5.53979L13.0608 6.11789L12.4536 5.53979Z"
                        fill="white"
                      />
                      <path
                        d="M5.50167 0.639833L7.92069 2.92405L7.32008 3.49746L5.32082 1.61431V6.16865H4.45807V1.61431L2.45881 3.49746L1.85156 2.92092L4.28054 0.639833L4.88281 0.0585938L5.50167 0.639833Z"
                        fill="white"
                      />
                      <path
                        d="M0 6.99219V24.0001H18V6.99219H0ZM16.3608 22.5196H1.62264V8.46017H16.3608V22.5196Z"
                        fill="white"
                      />
                    </svg>
                  </button>
                )}
              </div>
            </Fragment>
          )}
        </div>
      )}

      <div
        className={`modal-search ${
          isFormModalOpen ? "modal-search-is-open" : "modal-search-is-close"
        }`}
      >
        <div className="modal-search-close">
          <i className="icon-close" onClick={handleClose} />
        </div>
        <div className="search-form">
          <input
            placeholder="Where are you at?"
            onFocus={() => setIsHistoryOpen(false)}
            value={keyword.from}
            onChange={(e) => handleChangeKeyword("from", e.target.value)}
          />
          <i className="icon-search" />
        </div>
        <div className="modal-search-content">
          {isHistoryOpen && (
            <Fragment>
              <p>Search History</p>
              <ScrollList>
                <ul>
                  {histories.length > 0 &&
                    histories
                      .reverse()
                      //   .slice(0, 10)
                      .map((history, index) => {
                        return (
                          <li key={index}>
                            <div
                              onClick={() =>
                                handleClickHistory("from", history)
                              }
                            >
                              <i className="icon-clock" />
                              {history}
                            </div>
                            {/* <button
                              className="button-remove"
                              onClick={() => handleDeleteHistory(index)}
                            >
                              <i className="icon-close" />
                            </button> */}
                          </li>
                        );
                      })}
                </ul>
              </ScrollList>
            </Fragment>
          )}
          {!isHistoryOpen && (
            <ScrollList>
              <ul>
                {filteredPois
                  // .slice(0, 10)
                  .map((poi, index) => {
                    return (
                      <li key={poi.id}>
                        <div
                          className="poi-content"
                          key={index}
                          onClick={() => handleClickFrom(poi)}
                        >
                          <div className={`poi-tags ${checkTags(poi.tags)}`} />
                          <div
                            className={
                              poi.new ? "poi-name-disabled" : "poi-name"
                            }
                          >
                            {poi.name}
                          </div>
                          <div className="poi-number">{poi.places}</div>
                          {poi.new && (
                            <div className="badge-new">Coming Soon</div>
                          )}
                        </div>
                      </li>
                    );
                  })}
              </ul>
            </ScrollList>
          )}
        </div>
        <p className="help-text">Please Type Use Your Keyboard</p>
      </div>

      <div
        className={`modal-search ${
          isFormModalPoiOpen ? "modal-search-is-open" : "modal-search-is-close"
        }`}
      >
        <div className="modal-search-close">
          <i className="icon-close" onClick={handleClosePoi} />
        </div>
        <div className="search-form">
          <input
            placeholder="Where are going to?"
            onFocus={() => setIsHistoryPoiOpen(false)}
            value={keyword.to}
            onChange={(e) => handleChangeKeyword("to", e.target.value)}
          />
          <i className="icon-search" />
        </div>
        <div className="modal-search-content">
          {isHistoryPoiOpen && (
            <Fragment>
              <p>Search History</p>
              <ScrollList>
                <ul>
                  {historiesPois.length > 0 &&
                    historiesPois
                      .reverse()
                      //   .slice(0, 10)
                      .map((history, index) => {
                        return (
                          <li key={index}>
                            <div
                              onClick={() =>
                                handleClickHistoryPoi("to", history)
                              }
                            >
                              <i className="icon-clock" />
                              {history}
                            </div>
                            {/* <button
                              className="button-remove"
                              onClick={() => handleDeleteHistoryPoi(index)}
                            >
                              <i className="icon-close" />
                            </button> */}
                          </li>
                        );
                      })}
                </ul>
              </ScrollList>
            </Fragment>
          )}
          {!isHistoryPoiOpen && (
            <ScrollList>
              <ul>
                {filteredPois
                  // .slice(0, 10)
                  .map((poi, index) => {
                    return (
                      <li key={poi.id}>
                        <div
                          className="poi-content"
                          key={index}
                          onClick={() => handleClickPoi(poi)}
                        >
                          <div className={`poi-tags ${checkTags(poi.tags)}`} />
                          <div
                            className={
                              poi.new ? "poi-name-disabled" : "poi-name"
                            }
                          >
                            {poi.name}
                          </div>
                          <div className="poi-number">{poi.places}</div>
                          {poi.new && (
                            <div className="badge-new">Coming Soon</div>
                          )}
                        </div>
                      </li>
                    );
                  })}
              </ul>
            </ScrollList>
          )}
        </div>
        <p className="help-text">Please Type Use Your Keyboard</p>
      </div>
      {renderMap()}
      <div className="map-footer">
        <span>
          <i className="icon-map-marker-f mr-1" />3 Temasek Blvd, Singapore
          038983
        </span>
        <span>
          <i className="icon-message-alt-writing-f mr-1" />
          <a
            href="https://quickchat.sunteccity.com.sg/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Quick chat
          </a>
        </span>
      </div>
    </div>
  );
}

export default App;
